var $487db6faca3494c5$exports = {};
$487db6faca3494c5$exports = {
    "breadcrumbs": `\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{648}\u{627}\u{62C}\u{647}\u{629}`
};


export {$487db6faca3494c5$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
